<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent icono-titulo="fas fa-boxes" texto-titulo="Aplicar aumentos"></TituloComponent>
    <div class="main-card mb-3 card col-12">
      <div class="card-body">
        <form @submit.prevent="guardarArticulo()">
          <div class="row">
            <div class="col-md-2 col-12">
              <button type="button" @click="modalArticulo= true" class="btn btn-info btn-block">Buscar por nombre</button>
            </div>
            <h4 class="w-100 text-center">{{articulo.descripcion}}</h4>
            <FloatLabel label="Precio de venta" clase="offset-md-3 col-md-6 col-12" prepend="$">
              <input
                v-model="articulo.precio_venta"
                id="precio_venta"
                inputmode="numeric"
                placeholder="0.00"
                readonly
                type="text"
                class="form-control"
                :class="(enviado && (!$v.articulo.precio_venta.required || !$v.articulo.precio_venta.decimal)) ? 'is-invalid' : ''"
              />
            </FloatLabel>
            <FloatLabel label="Porcentaje de aumento:" clase="offset-md-3  col-md-6 col-12" append="%">
              <input
                v-model="porcentaje_aumento"
                id="porcentaje_aumento"
                inputmode="numeric"
                placeholder="0.00"
                type="text"
                class="form-control"
                :class="(enviado && (!$v.porcentaje_aumento.required || !$v.porcentaje_aumento.decimal)) ? 'is-invalid' : ''"
              />
            </FloatLabel>
            <FloatLabel label="Precio actualizado:" clase="offset-md-3  col-md-6 col-12" prepend="$">
              <input
                v-model="precio_actualizado"
                id="precio_actualizado"
                inputmode="numeric"
                placeholder="0.00"
                readonly
                type="text"
                class="form-control"
                :class="(enviado && (!$v.precio_actualizado.required || !$v.precio_actualizado.decimal)) ? 'is-invalid' : ''"
              />
            </FloatLabel>
          </div>
          <button class="mt-1 btn btn-info float-right">Guardar</button>
        </form>
      </div>
    </div>
      <ModalSelectArticulo ref="selectArticulo"
        v-if="modalArticulo"
        @selectArticulo="onSelectArticulo"
        @cerrarModalArticulo="modalArticulo = false"
      ></ModalSelectArticulo>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import ModalSelectArticulo from "@/components/views/articulos/ModalSelectArticulo";
import BlockUI from "@/components/loaders/BlockUI";
import { required, decimal } from "vuelidate/lib/validators";
import FloatLabel from "@/components/layouts/FloatLabel";
import axios from "axios";
import Swal from "sweetalert2";
import Articulo from "@/models/articulo";
export default {
  name: "AplicarAumento",
  components: {
    TituloComponent,
    ModalSelectArticulo,
    FloatLabel,
    BlockUI,
  },
  data() {
    return {
      articulo: new Articulo(
        null,
        "",
        null,
        null,
        null,
        null,
        null,
        null,
        5
      ),
      precio_actualizado: 0,
      precio_compra_actualizado: 0,
      porcentaje_aumento: null,
      loading: false,
      enviado: false,
      modalArticulo: false,
    };
  },
  validations: {
    articulo: {
      precio_venta: { required, decimal },
    },
    porcentaje_aumento: { required, decimal },
    precio_actualizado: { required, decimal },
  },
  watch: {
    porcentaje_aumento: function () {
      this.calcularAumento();
    },
  },
  mounted() {},
  methods: {
    guardarArticulo() {
      this.enviado = true;
      this.loading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        return false;
      }
      this.articulo.precio_venta = this.precio_actualizado;
      this.articulo.precio_compra = this.precio_compra_actualizado;
      axios
        .put("/articulos/" + this.articulo.id, this.articulo)
        .then((res) => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.articulo.descripcion} se guardó con éxito.`,
            });

            this.articulo = new Articulo(
              null,
              "",
              null,
              null,
              0,
              null,
              null,
              null,
              5
            );
            this.precio_actualizado = 0;
            this.precio_compra_actualizado = 0;
            this.porcentaje_aumento = null;
            this.enviado = false;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => (this.loading = false));
    },
    onSelectArticulo(articulo) {
      this.articulo = articulo;
      this.calcularAumento();
      this.modalArticulo= false;
    },
    calcularAumento() {
        if(this.porcentaje_aumento == null && this.articulo.id == null){
            this.precio_actualizado = null;
            this.precio_compra_actualizado = null;
        }else if (isNaN(parseFloat(this.porcentaje_aumento))) {
        this.precio_actualizado = parseFloat(this.articulo.precio_venta);
        this.precio_compra_actualizado = parseFloat(this.articulo.precio_compra);
      }else{
          this.precio_actualizado = parseFloat((parseFloat(this.articulo.precio_venta) * (1+(parseFloat(this.porcentaje_aumento)/100))).toFixed(2));
          this.precio_compra_actualizado = parseFloat((parseFloat(this.articulo.precio_compra) * (1+(parseFloat(this.porcentaje_aumento)/100))).toFixed(2));
      }
    },
  },
};
</script>
